export enum ApiDataTypes {
  ActiveClients,
  ArchivedClients,
  ActiveEvents,
  ArchivedEvents,
  Users,
  Shops,
  DefaultClipConfiguration,
}
